import { faFlag } from '@fortawesome/pro-regular-svg-icons'
import { faCoffee, faDownload, faFlagCheckered, faLocationDot, faUpload } from '@fortawesome/pro-solid-svg-icons'
import { styled } from '@mui/material'
import { GridRenderCellParams } from '@mui/x-data-grid-premium'

import { Icon } from '../../Icon/Icon'

export type StopTypeGridCellProps = GridRenderCellParams & {
  //
}

export const StopTypeGridCell: React.FC<StopTypeGridCellProps> = ({ value }) => {
  const getStopTypeIcon = (stopType: string) => {
    if (stopType === 'Start') {
      return <StyledIcon icon={faFlag} />
    } else if (stopType === 'Finish') {
      return <StyledIcon icon={faFlagCheckered} />
    } else if (stopType === 'Break') {
      return <StyledIcon icon={faCoffee} />
    } else if (stopType === 'Location') {
      return <StyledIcon icon={faLocationDot} />
    } else if (stopType === 'Pickup') {
      return <StyledIcon icon={faUpload} />
    } else if (stopType === 'Delivery') {
      return <StyledIcon icon={faDownload} />
    }

    return null
  }

  return (
    <StyledContainer>
      {getStopTypeIcon(value)}
      {value}
    </StyledContainer>
  )
}

const StyledContainer = styled('div')`
  display: inline-flex;
  justify-content: flex-start;
  align-items: center;
`

const StyledIcon = styled(Icon)`
  font-size: 18px;
  margin-right: 5px;
`